module.exports = __webpack_public_path__ + "img/results-main-banner.73fc9332.png";